<template>
    <div v-if="campaign != null" class="max-w-500 w-full h-full mx-auto" data-cy="container_survey_main">
        <template v-if="state === 'welcome'" class="px-4 py-5">
            <Welcome data-cy="component_survey_welcome" @setStep="setStep($event)"/>
        </template>
        <template v-if="state === 'question'">
            <QuestionList
                data-cy="component_survey_question_list"
                v-if="questionData"
                :questionList="questionData.pages"
                @setStep="setStep($event)"
                @submitQuizScores="submitQuizScores($event)"/>
        </template>
        <template v-if="state === 'result'">
            <Result v-if="animal != ''"
                data-cy="component_survey_result"
                :animal="animal"
                @goToPlankton="goToPlankton()"/>
        </template>
    </div>
</template>

<script>
// Helper
import Util from '@/helper/Utility.js';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin';
// service
import BzbsSurvey from '@/core/Campaign/service/BzbsSurvey';
import BzbsRedeem from '@/core/Redeem/service/BzbsRedeem';
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import {
    RedeemConfigBuilder,
    RedeemInfoConfigBuilder
} from '@/core/Redeem/config/RedeemConfigBuilder.js';
//controller
import { DetailController } from '../../Detail/controller/DetailController';
// component
import Welcome from '../component/Welcome.vue';
import QuestionList from '../component/QuestionList.vue';
import Result from '../component/Result.vue';
export default {
    name: "Survey",
    mixins: [ModalMixin, AuthStatusMixin, LocaleMixin],
    components: {
        Welcome,
        QuestionList,
        Result
    },
    data() {
        return {
            surveyId: null,
            isLoaded: false,
            detailController: new DetailController(),
            campaign: null,
            state: 'welcome',
            questionData: {},
            animal: '',
            redeemConfigBuilder: new RedeemConfigBuilder(),
            info1Data: [],
            activeTime: 0,
            activeTimeInterval: null
        };
    },
    created: function() {
        // หยุดนับเวลาเมื่อ component ถูกสร้าง
        this.stopActiveTimeCounter();
        // เริ่มนับเวลาเมื่อเข้าสู่หน้า survey
        this.startActiveTimeCounter();
    },
    activated() {
        if (this.isLoaded) {
            this.getSurveyResult().then(() => {
                this.initialCampaign();
            });
        }
    },
    methods: {
        onAccountInit: async function() {
            await this.getSurveyResult();
            this.initialCampaign();
        },
        getSurveyResult: function() {
            return new Promise((resolve) => {
                BzbsSurvey.apiGetSurveyResult().subscribe({
                    next: (res) => {
                        Util.log("getSurveyResult", res);
                        if (!Util.isEmptyStr(res)) {
                            this.animal = res.Name.toLowerCase();
                            // หยุดนับเวลาเมื่อพบผลลัพธ์เก่า (จะไปหน้า result)
                            this.stopActiveTimeCounter();
                            this.$nextTick(() => {
                                this.setStep('result');
                            });
                        }
                        resolve(res);
                    },
                    error: (err) => {
                        Util.log("getSurveyResult err", err);
                        resolve(null);
                    },
                })
            })
        },
        initialCampaign: function () {
            var surveyId = this.$route.params.surveyId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(surveyId)
                .create();

            this.setupDetailController();
        },
        setupDetailController: function() {
            this.modal.loadingModal.show();
            this.detailController.initial(this.campaignConfig).then((campaign) => {
                this.campaign = campaign;
                console.log('setupDetailController', campaign);
                const extra = JSON.parse(campaign.extra)
                this.questionData = extra.survey || {};
                this.onLoadedCampaign();
            }).catch((err) => {
                this.errorApi(err);
            }).finally(() => {
                this.modal.loadingModal.hide();
            });
        },
        onLoadedCampaign: function() {
            this.isLoaded = true;
        },
        setStep: function(step) {
            this.state = step;
        },
        submitQuizScores: async function(quizScores) {
            // สร้าง RedeemDate ใน format 'YYYY-MM-DD HH:mm:ss'
            const now = new Date();
            const pad = (n) => n.toString().padStart(2, '0');
            const redeemDate = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
            let params = {
                TopicType: "Animal",
                QuizScores: quizScores,
                ActiveTime: this.activeTime,
                RedeemDate: redeemDate,
                Point: this.campaign.pointPerUnit
            }

            this.info1Data = [];
            for (let i = 0; i < params.QuizScores.length; i++) {
                this.info1Data.push({ answer: params.QuizScores[i].Score });
            }

            this.modal.loadingModal.show();
            await this.callSubmitApi(params);
            await this.callApiRedeem();
            this.modal.loadingModal.hide();
            this.$nextTick(() => {
                window.location.reload();
            });
        },
        callSubmitApi: function(params) {
            return new Promise((resolve) => {
                BzbsSurvey.apiSubmitGoldenQuestion(params).subscribe({
                    next: (res) => {
                        Util.log("submitGoldenQuestion", res);
                        if (!Util.isEmptyStr(res)) {
                            this.animal = res.Name.toLowerCase();
                        }
                        resolve(res);
                    },
                    error: (err) => {
                        Util.log("submitGoldenQuestion err", err);
                        this.errorApi(err);
                        resolve(null);
                    },
                })
            })
        },
        callApiRedeem: function() {
            let activeTimeObj = {
                activetime: this.activeTime
            }
            let info = new RedeemInfoConfigBuilder();
            info.setInfo1(JSON.stringify(this.info1Data));
            info.setInfo3(JSON.stringify(activeTimeObj));
            this.redeemConfigBuilder.redeemInfoConfigBuilder = info;

            const params = this.redeemConfigBuilder.getRedeemParams();
            // หยุดนับเวลา
            this.stopActiveTimeCounter();

            return new Promise((resolve) => {
                BzbsRedeem.apiRedeemCampaign(this.campaign.id, params, null, true).subscribe({
                    next: (res) => {
                        Util.log("apiRedeemCampaign", res);
                        resolve(res);
                    },
                    error: (err) => {
                        Util.log("apiRedeemCampaign err", err);
                        this.errorApi(err);
                        resolve(null);
                    }
                })
            })
        },
        goToPlankton: function() {
            this.$router.replace('/history/point');
        },
        startActiveTimeCounter: function() {
            // หยุด interval เก่าก่อน (ถ้ามี)
            this.stopActiveTimeCounter();

            // เริ่มนับเวลาทุกวินาที
            this.activeTimeInterval = setInterval(() => {
                this.activeTime++;
            }, 1000);
        },
        stopActiveTimeCounter: function() {
            if (this.activeTimeInterval) {
                clearInterval(this.activeTimeInterval);
                this.activeTimeInterval = null;
            }
        }
    },
}
</script>
<style scoped lang="scss">
</style>
